import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const NotAvailable = () => {
  return (
    <Box className="px-8 py-10  bg-tc-6">
      <Box className="flex justify-between">
        <Typography variant="h1" className="text-2xl font-bold">
          Loading ...
        </Typography>
      </Box>
    </Box>
  );
};

export default NotAvailable;
